<template>
    <referFriends />
</template>

<script>
//Components
import referFriends from "@/app/components/refer-friends/referFriends";

export default {
    name: 'ReferFriendsView',
    components: { referFriends }
}
</script>

<style>

</style>